<!-- If we're loading -->
<ng-template #loading>
  <mat-form-field appearance="outline">
    <mat-label>{{ field?.label }} ...</mat-label>
    <input disabled
           matInput>
    <mat-spinner [diameter]="18"
                 matSuffix
                 style="float: right; margin-left: 8px"></mat-spinner>
  </mat-form-field>
</ng-template>
<ng-container *ngIf="!field?.optionData?.loading && (filteredData$ | async) as options; else loading">
  <mat-form-field [formGroup]="group"
                  [hideRequiredMarker]="field?.hideRequiredMarker"
                  appearance="outline"
                  class="demo-full-width margin-top">
    <mat-label>{{ field?.label }}</mat-label>

    <!--        <mat-select (openedChange)="openedChange($event)" gInfiniteScroll (infiniteScroll)="getNextBatch()"-->
    <mat-select (openedChange)="openedChange($event)"
                (selectionChange)="fieldChange($event)"
                [formControlName]="field?.key || null"
                [multiple]="field?.multiple"
                [placeholder]="field?.placeholder || ''"
                [required]="required">
      <ng-container *ngIf="!showTable">
        <mat-option class="multiline-mat-option">
          <ng-template [ngIf]="!field?.multiple">
            <!--disableScrollToActiveOnOptionsChanged should be set to true-->
            <app-select-search [disableScrollToActiveOnOptionsChanged]="true"
                               [formControl]="searchCtrl"
                               [noEntriesFoundLabel]="noEntriesFoundLabel">
            </app-select-search>
          </ng-template>
          <ng-template [ngIf]="field?.multiple">
            <app-select-search (toggleAll)="toggleSelectAll($event)"
                               [formControl]="searchCtrl"
                               [noEntriesFoundLabel]="noEntriesFoundLabel"
                               [showToggleAllCheckbox]="true"
                               [toggleAllCheckboxChecked]="(field && field.key && (group.controls[field.key]?.value || []).length === (field?.optionData?.value || []).length) || false"
                               [toggleAllCheckboxIndeterminate]="(field && field.key && (group.controls[field.key]?.value || []).length > 0 && (group.controls[field.key]?.value || []).length < (field?.optionData?.value || []).length) || false">
            </app-select-search>
          </ng-template>
        </mat-option>
        <mat-option *ngIf="!field?.multiple">--- Select ---</mat-option>
        <span *ngIf="!field?.removeUnderscore" class="!text-gray-500">
        
          <mat-option
            *ngFor="let item of (options || []) | disableDuplicate:field.duplicateCheckKey | search: 'name': searchCtrl.value"
            [disabled]="item.disabled"
            [ngClass]="{'multiline-mat-option': true,'danger': item.danger}" [value]="item.value">
            
            <span class="flex flex-wrap items-center">
              <mat-icon *ngIf="field?.useSvgNameAsIcon" [svgIcon]="item?.name" class="mx-1"></mat-icon>
               <span [innerHtml]="item?.name | dynamicPipes:  field?.dynamicPipes || []"></span>
            </span>
          </mat-option>
          <mat-option *ngIf="field?.showOtherOption" [value]="'Other'">Other</mat-option>
        </span>
      </ng-container>
    </mat-select>
    <mat-progress-spinner *ngIf="field?.isLoading" diameter="20" matSuffix mode="indeterminate"></mat-progress-spinner>

    <mat-icon *ngIf="field?.icon" matPrefix>{{ field?.icon }}</mat-icon>
    <mat-hint><strong>{{ field?.hint }}</strong></mat-hint>
    <ng-container *ngFor="let validation of field?.validations;"
                  ngProjectAs="mat-error">
      <mat-error
        *ngIf="field && field.key && group.controls[field.key]?.hasError(validation.name)">{{ validation.message }}
      </mat-error>
    </ng-container>
    <button (click)="showTableFn()"
            *ngIf="field?.tableColumns"
            color="primary"
            mat-icon-button
            matSuffix
            type="button">
      <mat-icon>visibility</mat-icon>
    </button>
  </mat-form-field>
</ng-container>
